var video_global_vars_module = {};

video_global_vars_module.user_paused = 0;
video_global_vars_module.videos_container = $('.js-video-container');

export default video_global_vars_module